import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { LogoHaGiang } from "../../../svg";

interface StationData {
  station: {
    name: string;
  };
  time: string;
  nreTypeName: string;
  agentName: string;
}

interface LedHeaderProps {
  stationData: StationData;
}

const MonitoringImageHeader: React.FC<LedHeaderProps> = ({ stationData }) => {
  const [currentTime, setCurrentTime] = useState<string>("");
  const [currentDate, setCurrentDate] = useState<string>("");

  const theme = useTheme();
  const isSmallScreen = useMediaQuery("(max-width: 800px)");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setCurrentTime(
        now.toLocaleTimeString("vi-VN", {
          hour: "2-digit",
          minute: "2-digit",
        })
      );

      const options: Intl.DateTimeFormatOptions = {
        weekday: "long",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      setCurrentDate(now.toLocaleDateString("vi-VN", options));
    };

    updateTime();
    const intervalId = setInterval(updateTime, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 1,
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Avatar
          src={LogoHaGiang}
          sx={{
            width: isSmallScreen ? 50 : 75,
            height: isSmallScreen ? 50 : 75,
          }}
        />
        <Typography
          variant="h6"
          mt={1}
          sx={{
            fontWeight: "bold",
            fontSize: isSmallScreen ? "1rem" : "2rem",
          }}
        >
          {/* Trạm  */}
          {/* {stationData?.nreTypeName} */}
        </Typography>
      </Box>
      <Box sx={{ flexGrow: 1, textAlign: "center" }}>
        {/* <Typography
          mb={1}
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "red",
            fontSize: isSmallScreen ? "1.2rem" : "2rem",
            textTransform: "uppercase",
          }}
        >
          {stationData?.agentName}
        </Typography>
        <Typography
          variant="h6"
          mb={1}
          sx={{
            fontWeight: "bold",
            color: "darkblue",
            fontSize: isSmallScreen ? "1.2rem" : "2rem",
            textTransform: "uppercase",
          }}
        >
          {stationData?.station?.name}
        </Typography> */}
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: "bold",
            color: "white",
            fontSize: isSmallScreen ? "1rem" : "1.5rem",
            textTransform: "uppercase",
          }}
        >
          KẾT QUẢ QUAN TRẮC TỰ ĐỘNG LIÊN TỤC
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          marginLeft: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: isSmallScreen ? 25 : 40,
            fontWeight: "bold",
            marginBottom: 1,
          }}
        >
          {currentTime}
        </Typography>
        <Typography
          sx={{ fontSize: isSmallScreen ? 15 : 20, fontWeight: "bold" }}
        >
          {currentDate}
        </Typography>
      </Box>
    </Box>
  );
};

export default MonitoringImageHeader;
